/** Expense red stays; income uses teal so the pair is not red-vs-emerald. */
import {
  CHART_INVESTMENTS_FINANCE,
  CHART_INVESTMENTS_PROPERTY,
  CHART_MORTGAGE_LUMP,
} from './personalFinancesHousehold';

export const CASHFLOW_EXPENSES_FILL = '#DC2626';
export const CASHFLOW_INCOME_FILL = '#0F766E';
export const CASHFLOW_TRANSFERS_FILL = '#2563EB';
export const CASHFLOW_INVESTMENTS_FILL = '#4338CA';
export const CASHFLOW_INVESTMENTS_FINANCE_FILL = '#0E7490';
export const CASHFLOW_MORTGAGE_LUMP_FILL = '#B45309';
export const CASHFLOW_UNKNOWN_FILL = '#FF2D92';
export const CASHFLOW_REFUNDS_FILL = '#7C3AED';
export const CASHFLOW_REVERTED_FILL = '#EA580C';
export const CASHFLOW_NA_FILL = '#64748B';

export function cashflowFill(side: string): string {
  if (side === 'Income') return CASHFLOW_INCOME_FILL;
  if (side === 'Expenses') return CASHFLOW_EXPENSES_FILL;
  if (side === 'Internal Transfers') return CASHFLOW_TRANSFERS_FILL;
  if (side === CHART_INVESTMENTS_PROPERTY || side === 'Investments') return CASHFLOW_INVESTMENTS_FILL;
  if (side === CHART_INVESTMENTS_FINANCE) return CASHFLOW_INVESTMENTS_FINANCE_FILL;
  if (side === CHART_MORTGAGE_LUMP) return CASHFLOW_MORTGAGE_LUMP_FILL;
  if (side === 'Refunds') return CASHFLOW_REFUNDS_FILL;
  if (side === 'Reverted') return CASHFLOW_REVERTED_FILL;
  if (side === 'Unknown') return CASHFLOW_UNKNOWN_FILL;
  if (side === 'N/A') return CASHFLOW_NA_FILL;
  return CASHFLOW_UNKNOWN_FILL;
}

/** Drill-down bars keep the parent cashflow colour. Unknown stays pink at every level. */
export function householdChartRowFill(name: string, cashflow = ''): string {
  if (name === 'Unknown') return CASHFLOW_UNKNOWN_FILL;
  return cashflowFill(cashflow || name);
}

export const HOUSEHOLD_CHART_UNSELECTED_OPACITY = 0.35;

/** Full colour for the selected category bar; sibling bars fade. */
export function householdChartBarOpacity(
  rowName: string,
  selectedName: string | string[] | null | undefined
) {
  const selected = (Array.isArray(selectedName) ? selectedName : [selectedName || ''])
    .map((name) => String(name || '').trim())
    .filter(Boolean);
  if (!selected.length) return 1;
  return selected.includes(rowName) ? 1 : HOUSEHOLD_CHART_UNSELECTED_OPACITY;
}

export const CASHFLOW_INCOME_CHIP_SX = {
  backgroundColor: CASHFLOW_INCOME_FILL,
  color: '#F0FDFA',
  borderColor: CASHFLOW_INCOME_FILL,
};

export const CASHFLOW_UNKNOWN_CHIP_SX = {
  backgroundColor: CASHFLOW_UNKNOWN_FILL,
  color: '#FFFFFF',
  borderColor: CASHFLOW_UNKNOWN_FILL,
};

export const CASHFLOW_INVESTMENTS_CHIP_SX = {
  backgroundColor: CASHFLOW_INVESTMENTS_FILL,
  color: '#EEF2FF',
  borderColor: CASHFLOW_INVESTMENTS_FILL,
};

export const CASHFLOW_INVESTMENTS_FINANCE_CHIP_SX = {
  backgroundColor: CASHFLOW_INVESTMENTS_FINANCE_FILL,
  color: '#ECFEFF',
  borderColor: CASHFLOW_INVESTMENTS_FINANCE_FILL,
};

export const CASHFLOW_MORTGAGE_LUMP_CHIP_SX = {
  backgroundColor: CASHFLOW_MORTGAGE_LUMP_FILL,
  color: '#FFFBEB',
  borderColor: CASHFLOW_MORTGAGE_LUMP_FILL,
};

export const CASHFLOW_REFUNDS_CHIP_SX = {
  backgroundColor: CASHFLOW_REFUNDS_FILL,
  color: '#F5F3FF',
  borderColor: CASHFLOW_REFUNDS_FILL,
};

export const CASHFLOW_REVERTED_CHIP_SX = {
  backgroundColor: CASHFLOW_REVERTED_FILL,
  color: '#FFF7ED',
  borderColor: CASHFLOW_REVERTED_FILL,
};

export const CASHFLOW_NA_CHIP_SX = {
  backgroundColor: CASHFLOW_NA_FILL,
  color: '#F8FAFC',
  borderColor: CASHFLOW_NA_FILL,
};

export function cashflowChipSx(side: string) {
  if (side === 'Income') return CASHFLOW_INCOME_CHIP_SX;
  if (side === 'Unknown') return CASHFLOW_UNKNOWN_CHIP_SX;
  if (side === CHART_INVESTMENTS_PROPERTY || side === 'Investments') return CASHFLOW_INVESTMENTS_CHIP_SX;
  if (side === CHART_INVESTMENTS_FINANCE) return CASHFLOW_INVESTMENTS_FINANCE_CHIP_SX;
  if (side === CHART_MORTGAGE_LUMP) return CASHFLOW_MORTGAGE_LUMP_CHIP_SX;
  if (side === 'Refunds') return CASHFLOW_REFUNDS_CHIP_SX;
  if (side === 'Reverted') return CASHFLOW_REVERTED_CHIP_SX;
  if (side === 'N/A') return CASHFLOW_NA_CHIP_SX;
  return {};
}
